import { z } from 'zod'

import { emptySelectOptionZod } from 'components/Select'
import {
  CommonOwnSchema,
  commonSchema,
  CommonThirdPartyProviderSchema,
  CommonYieldbirdSchema,
} from 'features/globalSetup/forms/Prebid/Bidders/schemas/commonSchema'
import { DEFAULT_CONSENT_MODE, DEFAULT_CPM_ADJUSTMENT } from '../constants'
import { BidderSlice } from '../types'

export type AddOwnSchema = CommonOwnSchema
export type AddSchema = z.infer<typeof commonSchema>
export type AddThirdPartyProviderSchema = CommonThirdPartyProviderSchema
export type AddYieldbirdSchema = Omit<CommonYieldbirdSchema, 'status'>

export const addSchemaDefault: AddSchema = {
  accountType: 'own',
  bidCpmAdjustment: DEFAULT_CPM_ADJUSTMENT,
  bidderCode: '',
  bidderId: emptySelectOptionZod<BidderSlice>(),
  bidderSid: '',
  consentMode: DEFAULT_CONSENT_MODE,
  priority: 'primary',
}
